module.exports = __webpack_public_path__ + "img/8hearts.070fea2d.jpg";